import Model from "./abstract/Model";

export const DAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

export default class OpeningHoursSlot extends Model {

    depot_id;
    days;
    start_time;
    end_time;
    
    constructor(props) {
        super();

        this.initializeAttributes(props);
    }
}
